module.exports = __webpack_public_path__ + "img/Logo-31.82866c02.svg";